<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :config="queryConfig" :queryOnLoad="true" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <el-table class="thin" :data="devcClassifyTagList" :height="theTableHeight" ref="deviceImpInfoTable" border style="width: 100%; font-size: 12px" @current-change="handleCurrentChange">
            <el-table-column width="55" align="center">
                <template slot-scope="rows">
                    <div class="copy-radio" :class="{'circle' : checkedId == rows.row.id}">
                        <div class="circle-dot"></div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" width="220" align="left"></el-table-column>
            <el-table-column prop="desc" label="描述" align="left"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="200" align="center"></el-table-column>
            <el-table-column prop="creatorName" label="创建人" width="200" align="left"></el-table-column>
        </el-table>
        <div name="pagination" class="block pagination-layout">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm } from '../index'

    import SwbPropEditor from '../ctrl/PropEditor';
    Vue.regist(SwbPropEditor);

    import SwbDevcClassifyTagSpecFieldList from './DevcClassifyTagSpecFieldList';
    Vue.regist(SwbDevcClassifyTagSpecFieldList);

    import merchtComnApi from '../../api/merchtComn'

    let mockConfigData = {
        "queryFields": [{
            "type": "Text",
            "label": "名称",
            "code": "name",
            "valueType": "String",
            "basic": true
        }, {
            "type": "Text",
            "label": "创建人",
            "code": "creatorName",
            "valueType": "String",
            "basic": true
        }],
        "sortFields": []
    };

    export default {
        name: 'swb-devc-classify-tag-list-select',
        desc: '归类标签',
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                theTableHeight: 300,
                //
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                queryConfig: {},
                //
                devcClassifyTagList: [],
                checkedId: null
            }
        },
        created: function () {
            this.queryConfig = Utils.merge([], mockConfigData);
            this.pageSize = this.pageSizes.first();
        },
        methods: {
            handleCurrentChange: function (val) {
                this.checkedId = val.id;
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDevcClassifyTagList();
            },
            getDevcClassifyTagList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                merchtComnApi.getDevcClassifyTagPageList(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        self.devcClassifyTagList = result.data.rows || [];
                        //
                        let resultData = result.data;
                        let pagination = resultData.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let result = {};
                let checkedId = this.checkedId;
                if(!Utils.isNoB(checkedId)) {
                    let checkedObj = null;
                    let devcClassifyTagList = this.devcClassifyTagList;
                    devcClassifyTagList.forEach(function (tag) {
                        if(checkedId == tag.id) {
                            checkedObj = tag;
                        }
                    });
                    result.type = 'info';
                    result.data = checkedObj;
                } else {
                    result.type = 'warn';
                    result.message = '请选择标签';
                }
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcCust/DevcClassifyTagListSelect.vue